<template>
      <div class="wrapper wrapper-content">
        <div class="container-fluid">


<div class="">
              
  
  
  
    
  
  
    
  


  <div class="row affiliate">
    <div class="col-lg-12">
      <div class="tabs-container">
        <ul class="nav nav-tabs">
          <li style="background:#eaeaea">
            <router-link :to="{name: 'affiliate'}" class="no-margins text-center"><i class="fa fa-fw fa-globe"></i> ภาพรวม</router-link>
          </li>
          <li style="background:#eaeaea">
            <router-link :to="{name: 'af_member'}" class="no-margins text-center text-nowrap"><i class="fa fa-fw fa-user-circle"></i> สมาชิก</router-link>
          </li>
          <li class="active">
            <router-link :to="{name: 'af_revenue'}" class="no-margins text-center text-nowrap"><i class="fa fa-fw fa-money"></i> รายได้</router-link>
          </li>
          <li style="background:#eaeaea">
            <router-link :to="{name: 'af_withdraw'}" class="no-margins text-center text-nowrap"><i class="fa fa-fw fa-bell"></i> แจ้งถอนรายได้</router-link>
          </li>
        </ul>

        <div class="tab-content">
          <div class="tab-pane active">
            <div class="panel-body p-xs">

              <div class="row">
              <div class="col-xs-12">
              <div class="alert alert-warning text-center" role="alert">รายได้ค่าแนะนำสมาชิก หรือระบบ aff ที่ท่านแนะนำได้ จะแสดงหลังจากหวยบิลนั้นออกผลแล้วนะค่ะ จึงแจ้งมาเพื่อทราบ ขอบคุณค่ะ</div>
              
              <div class="tab-content">
              <div class="tab-pane active">
              <div class="panel-body">

              <div class="row m-t-md m-b-md">
                <div class="col-xs-12 col-md-4 col-md-offset-4">
                  <form id="date_result" @submit.prevent="processForm" class="form-vertical">

                    <div class="input-group date">
                        <span class="input-group-addon">
                          <i class="fa fa-calendar"></i>
                        </span>
                        <date-picker v-model="date" :config="options" :wrap="true">
                        </date-picker>
                        <span class="input-group-btn">
                          <button class="btn btn-primary" type="submit">ตกลง</button>
                        </span>
                    </div>

                  </form>
                </div>
              </div>

              <table class="table table-bordered table-striped table-hover">
                <tbody>
                  
                  <tr v-for="(item, index) in days_in_month" :key="'dm-' + index">
                    <th style="width:50%;">{{ item.name }}</th>
                    <!-- <td>{{ aff_amount_data[index] || 0 }}</td> -->
                      <td>
                        <div v-if="aff_amount_data[index] > 0">
                          <div v-b-toggle="'collapse-' + index" size="sm">{{ fixDecimalValue(aff_amount_data[index]) }}</div>
                          <b-collapse :id="'collapse-' + index" class="mt-2">
                            <b-card>

                              <p class="card-text">รายได้ค่าแนะนำที่จ่ายแล้ว: {{ fixDecimalValue(aff_amount_detail[index]['paid']) }}</p>
                              <table border=1 style="width:100%" v-if="aff_amount_detail[index]['paid'] > 0">
                                <tr v-for="(value, key, index) in paid_user_data[index]" :key="'paid-' + index">
                                  <td width="70%" align="center">{{ key }} </td>
                                  <td width="30%" align="center">{{ fixDecimalValue(value) }}</td>
                                </tr>
                                <tr>
                                  <td width="70%" align="center">รวม </td>
                                  <td width="30%" align="center">{{ fixDecimalValue(aff_amount_detail[index]['paid']) }}</td>
                                </tr>
                              </table>

                              <p>&nbsp;</p>

                              <p class="card-text">รายได้ค่าแนะนำที่ยังไม่จ่าย: {{ fixDecimalValue(aff_amount_detail[index]['close']) }}</p>
                              <table border=1 style="width:100%" v-if="aff_amount_detail[index]['close'] > 0">
                                <tr v-for="(value, key, index) in close_user_data[index]" :key="'close-' + index">
                                  <td width="70%" align="center">{{ key }} </td>
                                  <td width="30%" align="center">{{ fixDecimalValue(value) }}</td>
                                </tr>
                                <tr>
                                  <td width="70%" align="center">รวม </td>
                                  <td width="30%" align="center">{{ fixDecimalValue(aff_amount_detail[index]['close']) }}</td>
                                </tr>
                              </table>

                            </b-card>
                          </b-collapse>
                        </div>
                        <div v-else>{{ fixDecimalValue(aff_amount_data[index]) }}</div>
                      </td>
                  </tr>
                                      
                  </tbody>
                <tfoot>
                    <tr class="active">
                      <th>ยอดรวม(เดือน)</th>
                      <td>
                        <div v-if="total_aff_amount > 0">
                          <div v-b-toggle.collapse-summay size="sm">{{ fixDecimalValue(total_aff_amount) }}</div>
                          <b-collapse id="collapse-summay" class="mt-2">
                            <b-card>
                              <p class="card-text">รายได้ค่าแนะนำที่จ่ายแล้ว: {{ fixDecimalValue(total_aff_paid) }}</p>
                              <p class="card-text">รายได้ค่าแนะนำที่ยังไม่จ่าย: {{ fixDecimalValue(total_aff_close) }}</p>
                            </b-card>
                          </b-collapse>
                        </div>
                        <div v-else>{{ fixDecimalValue(total_aff_amount) }}</div>
                      </td>
                    </tr>
                </tfoot>
              </table>
              </div>
              </div>
              </div>
              </div>
              </div>
            </div> <!-- /.ibox-content -->
          </div>
        </div> <!-- /.tab-content -->

      </div> <!-- /.tabs-container -->

    </div> <!-- /.col-lg-12 -->
  </div> <!-- /.row -->


            </div>


        </div>
      </div><!-- /#page-wrapper -->
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
moment.locale('th')

export default {
    name: 'af_revenue',
    data () {
        return {
            date: new Date(),
            current_date: moment( new Date() ).format('LL'),
            options: {
                format: 'MM/YYYY',
                useCurrent: false,
                viewMode: 'months',
                //locale: moment.locale('th')
            },
            days_in_month: [],
            aff_amount_data: {},
            aff_amount_detail: {},
            total_aff_amount: 0,
            total_aff_close: 0,
            total_aff_paid: 0,

            close_user_data: {},
            paid_user_data: {},
        }
    },
    computed: {
        ...mapState({
            user: state => state.user.user
        })
    },
    methods: {
        createReferLink () {

            if ( this.user ) {
                let baseUrl = location.origin
                this.refer_link = baseUrl + '/register/' + this.user.refer_token
            }
            return this.refer_link
        },

        async processForm () {
            //console.log('this date', this.date)

            let raw_date = this.date
            if ( typeof raw_date.getMonth === "function" ) {
                console.log('object', raw_date)
            }
            else {
                //console.log('string', raw_date)
                let [month, year] = raw_date.split("/")
                raw_date = new Date(year, month - 1)
            }

            await this.getAffiliateByMonth(raw_date)

        },

        async getAffiliateByMonth (raw_date) {

            if ( !raw_date ) {
                raw_date = new Date()
            }

            let month = raw_date.getMonth()
            let year  = raw_date.getFullYear()

            let date_result = raw_date.getTime()
            //console.log('date_result', date_result)

            try {

                const response = await this.$store.dispatch('affiliate/getAffiliateByMonth', date_result )
                //console.log('async initial getAffiliateMember', response)

                this.days_in_month = this.getDaysInMonth(month, year)
                //console.log('days_in_month', this.days_in_month)

                if ( response && response.length > 0  ) {

                    // clear object before get new data
                    this.clearVariableData()

                    this.total_aff_amount = 0
                    this.total_aff_close = 0
                    this.total_aff_paid = 0

                    // console.log('aff_amount_data', this.aff_amount_data)
                    for (let i = 0; i < response.length; i++) {
                        let day = response[i].day
                        let key = day - 1
                        //console.log('day', day, key)

                        this.aff_amount_data[key] = ( this.aff_amount_data[key] || 0 ) + response[i].amount

                        // if ( key === 25  ) {
                        //     console.log('25', key, response[i].username, response[i].amount, this.aff_amount_data[key])
                        // }

                        this.total_aff_amount = this.total_aff_amount + response[i].amount

                        if ( typeof this.aff_amount_detail[key] === "undefined" ) {
                            this.aff_amount_detail[key] = {}
                            // this.aff_amount_detail[key]['close'] = { total_amount: 0, data }
                        }

                        if ( typeof this.close_user_data[key] === "undefined" ) {
                            this.close_user_data[key] = {}
                        }

                        if ( typeof this.paid_user_data[key] === "undefined" ) {
                            this.paid_user_data[key] = {}
                        }

                        let username = response[i].username
                        if ( response[i].af_paid == 1 ) {
                            //not paid
                            this.aff_amount_detail[key]['close'] = ( this.aff_amount_detail[key]['close'] || 0 ) + response[i].amount

                            this.close_user_data[key][username] = ( this.close_user_data[key][username] || 0 ) + response[i].amount

                            this.total_aff_close = this.total_aff_close + response[i].amount
                        }
                        else {
                            //paid
                            this.aff_amount_detail[key]['paid'] = ( this.aff_amount_detail[key]['paid'] || 0 ) + response[i].amount

                            this.paid_user_data[key][username] = ( this.paid_user_data[key][username] || 0 ) + response[i].amount

                            this.total_aff_paid = this.total_aff_paid + response[i].amount
                        }

                    }
                }
                // console.log('aff_amount_data', this.aff_amount_data)
                // console.log('aff_amount_detail', this.aff_amount_detail)
                // console.log('close_user_data', this.close_user_data)
                // console.log('paid_user_data', this.paid_user_data)

            } catch (error) {
                this.$toasted.error('There was an error connecting to the server.')
            }

        },

        clearVariableData() {
            let report_var = ['aff_amount_detail', 'aff_amount_data', 'close_user_data', 'paid_user_data']
            for (let name of report_var) {
                for (const prop of Object.getOwnPropertyNames(this[name])) {
                    delete this[name][prop]
                }
            }
        },

        getDaysInMonth (month, year) {

            let date = new Date(year, month, 1)
            let days = []
            while (date.getMonth() === month) {
                //days.push(new Date(date))

                let days_data = {
                    name: moment(date).format('D MMMM YYYY'),
                    key: moment(date).format('D'),
                }
                days.push( days_data )

                date.setDate(date.getDate() + 1)
            }
            return days
        },

        fixDecimalValue (value) {
            let af_amount = 0
            if (value) {
                af_amount = value
            }
            return this.formatMoney(af_amount.toFixed(2))
        },

        formatMoney(num) {
            if (num) {
                return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            }
            return num
        },

    },
    created () {
        this.getAffiliateByMonth()

    },
    destroyed () {
    },
    mounted () {
    },
}
</script>

<style lang="sass" scoped>
</style>
